module.exports = __webpack_public_path__ + "static/glass_ball-717fc242d0e0909df0d30681e753bf0b.jpg";